module.exports = __webpack_public_path__ + "img/loading.8af2bb7c.svg";